import { useStateMachine } from "little-state-machine";
import { disableShipmentNotifications, enableShipmentNotifications } from "api";
import { useQueryClient } from "@tanstack/react-query";

import { ReactComponent as EnableNotificationIcon } from "assets/images/iconsV2/enable-notifications.svg";
import { ReactComponent as DisableNotificationIcon } from "assets/images/iconsV2/disable-notifications.svg";
import errorToast from "helpers/errorToast";
import testIds from "constants/testIds";
import { FormattedMessage } from "react-intl";
import { shipmentQueryKeys } from "api/queries/shipments/shipmentQueryKeys";
import ActionButton from "../TopNavV2/TopNavActions/ShipperProviderActions/ActionButton";

type NotificationMenuItemProps = {
  isNotificationEnabled: boolean;
};

function NotificationsMenuItem(props: NotificationMenuItemProps) {
  const { isNotificationEnabled } = props;
  const queryClient = useQueryClient();
  const { state }: any = useStateMachine({});

  function toggleShipmentNotificationsEnabled() {
    const toggleNotifications = isNotificationEnabled ? disableShipmentNotifications : enableShipmentNotifications;
    toggleNotifications(state.shipmentId)
      .then(() =>
        queryClient.setQueryData(shipmentQueryKeys.shipmentBasicDetails(state.shipmentId), (prevData: any) => {
          if (!prevData) {
            return undefined;
          }
          return {
            ...prevData,
            settings: {
              ...prevData.settings,
              notification_enabled: !isNotificationEnabled,
            },
          };
        }),
      )
      .catch((err) => errorToast(err));
  }

  return (
    <ActionButton
      onClick={toggleShipmentNotificationsEnabled}
      icon={
        isNotificationEnabled ? (
          <DisableNotificationIcon width={16} height={16} />
        ) : (
          <EnableNotificationIcon width={16} height={16} />
        )
      }
      title={
        isNotificationEnabled ? (
          <FormattedMessage
            id="components.molecules.navigation.disableNotifications"
            defaultMessage="Disable notifications"
          />
        ) : (
          <FormattedMessage id="components.molecules.navigation.enableNotifications" defaultMessage="Enable notifications" />
        )
      }
      testId={testIds.SHIPMENT_DASHBOARD_NOTIFICATIONS_TOGGLE_BUTTON}
    />
  );
}

export default NotificationsMenuItem;
